import styled, { css, createGlobalStyle, keyframes } from 'styled-components';
import { Field } from 'formik';
import { TermsAndConditions } from './components/form/termsAndConditions/TermsAndConditions';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0px;
  }
`
export const PageWrapper = styled.section`
  &,
  & * {
    box-sizing: border-box;
    display: inline-block;
  }

  @import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@700&display=swap');
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  font-style: normal;
  max-width: 38em;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem 0.75rem 1rem 0.75rem;
  border-radius: 4px;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  color: #313641;

  @media only screen and (max-width: 1200px) {
    display: block;
    width: 80%;
  }
`;

export const ConfirmWrapper = styled(PageWrapper)`
  max-width: 50em;

  @media only screen and (max-width: 1200px) {
    display: block;
    width: 100%;
  }
`;

export const Title = styled.h1`
  font-family: 'Lato', sans-serif;
  display: block;
  font-size: 2.5rem;
  line-height: 2.6rem;
  margin-top: 0.9rem;
  margin-bottom: .25em;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
  width: 100%;
`;

export const Subtitle = styled.h2`
  font-family: 'Lato', sans-serif;
  display: block;
  font-size: 1.1rem;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 1.15rem;
  margin-top: 0;
  width: 100%;
  color: #313641;
`;

export const SubtitleH3 = styled.h3`
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  font-style: normal;
  line-height: 1.15rem;
  margin-top: 0.5em;
  width: 100%;
  color: #313641;
`;

export const H3Bold = styled.h3`
  font-family: 'Lato', sans-serif;
  color: #313641;
  font-weight: 700;
  font-size: 1rem;
  font-style: normal;
  line-height: 1.15rem;
  margin-top: 0;
  width: 100%;
`;

export const Flex = styled.div`
  display: flex;
`;

export const Label = styled.label`
  margin-top: 1em;
  margin-bottom: 0px;
  font-size: 15px;
  width: 100%;
  display: inline-block;
`;

export const SubLabel = styled.label`
  float: right;
  display: inline-block;
  font-size: 11px;
  line-height: 18px;
`;

export const SubLabelIdProvider = styled.label`
  float: right;
  width: 75%;
  display: inline-block;
  font-size: 11px;
  line-height: 18px;
`;

export const CheckLabel = styled(Label)`
  display: inline-block;
  text-indent: 0px;
  margin-top: .5em;
`;

export const CheckField = styled(Field)`
  margin-right: 8px;
  display: inline-block;
`;

export const Input = styled(Field)`
  background-color: #f9f9f9;
  border: 1px solid lightgrey;
  border-radius: 4px;
  font-size: 1rem;
  line-height: 1.5rem;
  font-style: normal;
  font-weight: 400;
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.75rem 0.75rem;

  &:focus,
  &:active {
    box-shadow: rgb(210, 213, 217) 0px 0px 2px 1px, rgb(227, 230, 232) 0px 0px 0px
        3px;
    border: 1px solid rgb(26, 33, 43);
    outline: none;
  }

  /* Autocomplete styles in Chrome*/

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    border: 1px solid lightgrey;
    box-shadow: 0 0 0px 1000px #fff inset;
    -webkit-box-shadow: 0 0 0px 1000px #E7F4F7 inset;
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: black;
  }

  ${({ selected }) =>
    selected &&
    css`
      border: 1px solid lightgrey;
      background-color: #E7F4F7;

      &:focus,
      &:active {
        border: 1px solid #2aaecd;
        box-shadow: #2aaecd 0px 0px 2px 1px, #2aaecd 0px 0px
            0px 3px;
        outline: none;
      }

      /* Autocomplete styles in Chrome*/

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus {
        border: 1px solid #2aaecd;
      }
    `}

  ${({ error }) =>
    error &&
    css`
      border: 1px solid #DE4F45;
      outline: none;

      &:focus,
      &:active {
        box-shadow: rgb(244, 129, 116) 0px 0px 2px 1px, rgb(251, 178, 174) 0px 0px
            0px 3px;
        border: 1px solid #DE4F45;
        outline: none;
      }

      /* Autocomplete styles in Chrome*/

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus {
        border: 1px solid #DE4F45;
      }
    `}
`;

export const Dropdown = styled.select`
`;

export const Section = styled.section`
  display: block;
`;

export const StyledInlineErrorMessage = styled.div`
  font-size: 13px;
  background-color: #FFF2F1;
  color: #DE4F45;
  padding: .15em .75em .15em .75em;
  border-radius: 8px;
  margin-top: 0.5rem;
  white-space: pre-line;
`;

export const StyledInlineSuccessMessage = styled.div`
  font-size: 13px;
  background-color: #F7FFF8;
  color: #313641;
  padding: .15em .75em .15em .75em;
  margin-top: 0.25rem;
  white-space: pre-line;
`;

export const Submit = styled.button`
  width: 100%;
  margin-top: 1.5rem;

  background-color: #2aaecd;
  letter-spacing: .5px;
  font-family: Lato;
  border-radius: 5px;
  display: block;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  font-style: normal;
  font-weight: 700;
  height: 3rem;
  white-space: nowrap;
  color: rgb(255, 255, 255) !important;
  padding: 0.5rem 1rem;
  border-color: #2aaecd;
  /* border-style: hidden; */
  border-bottom: 3px solid #3584A1;

  &:active,
  &:focus,
  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: pointer;
    background-color: rgb(163, 168, 173);
    box-shadow: none;
    color: rgb(255, 255, 255) !important;
    border-style: hidden;

    &:hover,
    &:focus {
      cursor: not-allowed;
    }
  }
`;

export const SelectProvider = styled.button`
  position: relative;
  width: 48%;
  margin-top: .5rem;

  background-color: #f9f9f9;
  letter-spacing: .25px;
  font-family: Lato;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  font-style: normal;
  font-weight: 400;
  height: 3rem;
  white-space: nowrap;
  color: #979797 !important;
  border-style: solid;
  border-width: thin;
  border-color: #979797;
  border-radius: 5px;
  padding: 0.5rem 1rem;

  &:last-of-type {
    float: right;
  }

  &:active,
  &:focus,
  &:hover,
  &:target {
    cursor: pointer;
    background-color: #E7F4F7;
    color: #313641 !important;
    outline: initial;
    border-style: solid;
    border-width: thin;
    border-color: #979797;
  }
`;

export const ImageLarge = styled.img`
  width: 100%;
`;

export const ImageLargeContainer = styled.div`
  display: block;
  width: 50rem;
  margin-top: 12rem;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (max-width: 1200px) {
    display: block;
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: auto;
    margin-right: auto;
    width: 75%;
  }
`;

export const Img = styled.img`
  object-fit: Contain;
  object-position: left;
  display: block;
`;

export const ImageContainerCentered = styled.div`
  display: block;
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
`;

const LabelText = styled.p`
  display: inline-block;
  margin: 0px;
  flex-flow: column wrap;
`;

export const Checkbox = styled.input`
  position: absolute;
  opacity: 0;
`;

/* Layout */

export const LayoutStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
  font-family: 'Lato', sans-serif;
`;

export const BodyStyle = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;

  @media screen and (max-width: 1200px) {
      flex: 100%;
      flex-direction: column;
  }
`;
export const FooterStyle = styled.div`
  height: 2rem;
  display: flex;
  flex-direction: row;
  margin: 0px;

  @media screen and (max-width: 1200px) {
      flex: 100%;
      flex-direction: column;
  }
`;

/* Card */

export const CardWrapper = styled.div`
  display: flex;
  margin-top: 1em;

  @media screen and (max-width: 1200px) {
      flex-direction: column;
      padding-top: 0em;
      max-width: 10em;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  height: 70%;
  margin: 0px;

  @media screen and (max-width: 1200px) {
      flex-direction: column;
  }
`;

export const CardImg = styled.img`
  border-radius: 5px 5px 0 0;
  object-fit: cover;
`;

export const ImageContainer = styled.div`
  display: inline-block;
  width: 35%;
`;

export const Wrapper = styled.a`
    display: flex;
    flex-flow: column;
    -webkit-box-shadow: 1px 3px 5px -2px rgba(133,133,133,1);
    -moz-box-shadow: 1px 3px 5px -2px rgba(133,133,133,1);
    box-shadow: 1px 3px 5px -2px rgba(133,133,133,1);
    border-radius: 5px;
    margin: 0px 15px 0px 0px;
    height: 17rem;
    margin-bottom: .5em;
    text-decoration: none;

    :hover {
        -webkit-box-shadow: 1px 3px 6px 0px rgba(133,133,133,1);
        -moz-box-shadow: 1px 3px 6px 0px rgba(133,133,133,1);
        box-shadow: 1px 3px 6px 0px rgba(133,133,133,1);
        text-decoration: none;
        transition: .3s transform cubic-bezier(.155,1.105,.295,1.12),.3s box-shadow,.3s -webkit-transform cubic-bezier(.155,1.105,.295,1.12);
        transform: scale(1.005);
    }

    :active {
        opacity:0.8;
        -webkit-box-shadow: 1px 3px 5px -2px rgba(133,133,133,1);
        -moz-box-shadow: 1px 3px 5px -2px rgba(133,133,133,1);
        box-shadow: 1px 3px 5px -2px rgba(133,133,133,1);
        text-decoration: none !important;
    }

    a:active {
        text-decoration: none;
    }
`;

export const ImgContainer = styled.div`
    background-color: #f8f8f8;
    height: 70%;
    margin: 0px;
    border-radius: 5px 5px 0 0;
`;

export const TextContainer = styled.div`
    background-color: white;
    height: 30%;
    padding: 10px 0px 0px 10px;
    border-radius: 0 0 5px 5px;
    font-size: 0.80rem;
    color: #313641;
    text-decoration: none !important;
    display: block;
    line-height: 1.5em;

    h3 {
        margin: 0.30rem;
        font-size: 1.1rem;
        font-weight: 700;
        color: #313641;
        display: block;
        text-decoration: none !important;
    }

    p {
        margin: 0.30rem;
        font-size: 0.90rem;
        display: block;
        text-decoration: none !important;
    }
`;

/* Terms and conditions */

export const Modal = styled.div`
  display: flex;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
`;

export const Container = styled.div`
  width: 90%;
  height: 80%;
  -webkit-box-shadow: 0px 0px 17px 9px rgba(133,133,133,1);
  -moz-box-shadow: 0px 0px 17px 9px rgba(133,133,133,1);
  box-shadow: 0px 0px 17px 9px rgba(133,133,133,1);
  margin: auto;
`;

export const CloseBtn = styled.button`
  background-color: rgb(42,174,205);
  font-size: .75rem;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  margin-left: auto;
  margin-right: 0rem;
  float: right;
  text-transform: uppercase;
  width: 6em;
  height: 40px;
  border: none;
`;

export const TermsContainer = styled.div`
  box-sizing: none;
  display: inline;
`;

export const Link = styled.a`
  display: inline;
  white-space: normal;
  color: #2aaecd;
  margin: 0px;
  text-decoration: none;

  :hover {
    color: #1E7E95;
  }
`;

export const LinkSubtitle = styled.a`
  float: right;
  display: inline-block;
  white-space: normal;
  color: #2aaecd;
  margin-top: 3px;
  text-decoration: none;

  :hover {
    color: #1E7E95;
  }
`;

export const BorderBox = styled.div`
  margin-top: 1em;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #dadce0;
  box-shadow: none;
  max-width: 49em;

  @media only screen and (max-width: 1200px) {
    display: block;
    width: 80%;
  }
`;

export const BoxPadding = styled.div`
  display: flex;
  padding: 24px;
`;

export const IconContainer = styled.div`
  position: absolute;
`;
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
export const Spinner = styled.span`
  position: relative;
  font-size: 40px;
  width: 24px;
  height: 24px;
  top: 20px;
  left: 10px;
  animation: ${spin} 1s infinite;
`;